import http from '@/communication/AuthConnection'

export default async ({ commit }, { eventId }) => {
  const { data } = await http.get(`/v1/event/map/${eventId}`)
  if (data) {
    return data.eventItems
  } else {
    return Promise.reject(Error('Não foi possível carregar a listagem'))
  }
}



// WEBPACK FOOTER //
// ./src/brain/event-map/load-event/index.js